import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const cities = [
    "Horsens",
    "Vejle",
    "Aarhus",
    "Skanderborg",
    "Juelsminde",
    "Aalborg",
    "Herning",
    "Randers",
    "Fredericia",
    "Kolding",
    "Esbjerg",
    "Silkeborg",
    "Viborg",
    "Odense",
    "Svendborg",
    "Middelfart",
  ];

  return (
    <footer className="bg-[#0C332A] text-stone-300 pt-16 pb-12 border-t border-emerald-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 pb-12 border-b border-emerald-900/60">
          {/* Col 1: Brand & Bio */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=260,quality=90,format=auto/assets/769d49b2-5afc-461a-944c-d9cca711718f/quick-logo-p-01-0_d4719c06.webp"
                alt="ET Danmark ApS"
                className="h-10 sm:h-12 w-auto object-contain"
              />
            </Link>
            <div className="text-xs text-stone-400">
              CVR: 41026138
            </div>

            <p className="text-sm text-stone-300 leading-relaxed">
              Professionel og uvildig energirådgivning, energimærkning, trykprøvning og termografi med mere end 20 års erfaring i byggebranchen.
            </p>

            <div className="pt-2">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-950/80 border border-emerald-700/40 text-xs text-emerald-300">
                <i className="fa-solid fa-star text-emerald-400" aria-hidden="true"></i>
                <span className="font-medium">Høj kundetilfredshed på Trustpilot & Google</span>
              </div>
            </div>
          </div>

          {/* Col 2: Services */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-400"></span>
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/energimaerkning"
                  className="flex items-center justify-between text-stone-300 hover:text-white transition-colors group"
                >
                  <span className="group-hover:translate-x-1 transition-transform">Energimærkning</span>
                  <span className="text-xs text-stone-400 group-hover:text-emerald-300">Fra 4.188 kr.</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/trykproevning"
                  className="hover:text-emerald-300 transition-colors flex items-center justify-between group"
                >
                  <span>Trykprøvning / BlowerDoor</span>
                  <span className="text-xs text-stone-400 group-hover:text-emerald-300">Fra 3.300 kr.</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/termografi"
                  className="hover:text-emerald-300 transition-colors flex items-center justify-between group"
                >
                  <span>Termografi</span>
                  <span className="text-xs text-stone-400 group-hover:text-emerald-300">Fra 2.500 kr.</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/fugtmaaling"
                  className="hover:text-emerald-300 transition-colors flex items-center justify-between group"
                >
                  <span>Fugtmåling</span>
                  <span className="text-xs text-stone-400 group-hover:text-emerald-300">Fra 5.000 kr.</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/energiramme"
                  className="hover:text-emerald-300 transition-colors flex items-center justify-between group"
                >
                  <span>Energiramme</span>
                  <span className="text-xs text-stone-400 group-hover:text-emerald-300">Gratis tilbud</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/lca-beregning"
                  className="hover:text-emerald-300 transition-colors flex items-center justify-between group"
                >
                  <span>LCA-beregning</span>
                  <span className="text-xs text-stone-400 group-hover:text-emerald-300">Fra 7.500 kr.</span>
                </Link>
              </li>
              <li className="pt-2">
                <Link
                  to="/prisberegner"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-600/90 text-white text-xs font-semibold hover:bg-emerald-500 transition-colors shadow-xs"
                >
                  <i className="fa-solid fa-calculator text-[11px]" aria-hidden="true"></i>
                  <span>Prøv vores prisberegner</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Sider & Information */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-400"></span>
              Information
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-emerald-300 transition-colors">
                  Hjem
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-emerald-300 transition-colors">
                  Om os (20 års byggeerfaring)
                </Link>
              </li>
              <li>
                <Link to="/priser" className="hover:text-emerald-300 transition-colors">
                  Prisoversigt
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-emerald-300 transition-colors">
                  Billeder af arbejdet (Galleri)
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-emerald-300 transition-colors">
                  Kontakt os
                </Link>
              </li>
              <li>
                <a
                  href="https://www.iubenda.com/privacy-policy/39196843"
                  className="iubenda-white iubenda-noiframe iubenda-embed hover:text-emerald-300 transition-colors"
                  title="Privatlivspolitik "
                >
                  Privatlivspolitik
                </a>
              </li>
              <li>
                <a
                  href="https://www.iubenda.com/privacy-policy/39196843/cookie-policy"
                  className="iubenda-white iubenda-noiframe iubenda-embed hover:text-emerald-300 transition-colors"
                  title="Cookiepolitik "
                >
                  Cookiepolitik
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Kontaktinfo & Adresser */}
          <div>
            <h3 className="text-white font-semibold text-base mb-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-emerald-400"></span>
              Kontakt ET Danmark
            </h3>
            <div className="space-y-3.5 text-sm">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-emerald-400 mt-1 shrink-0" aria-hidden="true"></i>
                <div className="text-xs leading-relaxed">
                  <p className="font-semibold text-white">Adresse:</p>
                  <p>Bjerrevej 62 A, 8700 Horsens</p>
                </div>
              </div>

              <div className="flex items-center gap-3 pt-1">
                <i className="fa-solid fa-phone text-emerald-400 shrink-0" aria-hidden="true"></i>
                <div>
                  <a
                    href="tel:+4542499595"
                    className="font-bold text-white hover:text-emerald-300 transition-colors whitespace-nowrap text-base"
                  >
                    42 49 95 95
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-emerald-400 mt-0.5 shrink-0" aria-hidden="true"></i>
                <div>
                  <a
                    href="mailto:info@etdanmark.com"
                    className="text-stone-300 hover:text-emerald-300 transition-colors whitespace-nowrap block"
                  >
                    info@etdanmark.com
                  </a>
                  <span className="text-[11px] text-stone-400 block mt-0.5">
                    Vi bestræber os på at besvare mails inden for 24 timer
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Coverage Cities Bar */}
        <div className="py-6 border-b border-emerald-900/40 text-xs text-stone-400">
          <p className="font-semibold text-stone-300 mb-2">
            Få hjælp i din by – Vi rådgiver og udfører opgaver i hele Jylland & Fyn:
          </p>
          <div className="flex flex-wrap gap-2">
            {cities.map((city, idx) => (
              <span
                key={city}
                className="bg-emerald-950/70 border border-emerald-800/40 px-2.5 py-1 rounded-md text-stone-300 hover:text-white transition-colors"
              >
                {city}
              </span>
            ))}
            <span className="px-2 py-1 text-stone-400">m.fl.</span>
          </div>
        </div>

        {/* Bottom copyright line */}
        <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-stone-400">
          <p>
            Copyright &#169; 2026 - ET Danmark ApS , CVR 41026138
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a
              href="https://www.iubenda.com/privacy-policy/39196843"
              className="iubenda-white iubenda-noiframe iubenda-embed hover:text-emerald-300 transition-colors"
              title="Privatlivspolitik "
            >
              Privatlivspolitik
            </a>
            <span>•</span>
            <a
              href="https://www.iubenda.com/privacy-policy/39196843/cookie-policy"
              className="iubenda-white iubenda-noiframe iubenda-embed hover:text-emerald-300 transition-colors"
              title="Cookiepolitik "
            >
              Cookiepolitik
            </a>
            <span>•</span>
            <a
              href="https://www.facebook.com/profile.php?id=61583288765244"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors flex items-center gap-1.5"
            >
              <i className="fa-brands fa-facebook text-emerald-400" aria-hidden="true"></i>
              <span>Facebook</span>
            </a>
            <span>•</span>
            <span className="text-stone-400">
              Uvildig & certificeret rådgivning
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
